import { ValidationService } from '@/common/services/validation/validation.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'fe-special-offers-email',
    templateUrl: './special-offers-email.component.html',
    styleUrls: ['./special-offers-email.component.scss'],
})
export class SpecialOffersEmailComponent implements OnInit {
    public loadingBtnOffers = true;
    public formInfoOffers!: FormGroup;
    public urlActionInfo =
        'https://alamo.us15.list-manage.com/subscribe/post?u=df561e02dec04355ee8a75cb5&id=8b7d5c623c&f_id=001fc7e1f0';
    @ViewChild('formInfoOffersElement') formInfoOffersElement!: ElementRef;
    @ViewChild('formElement') formElement!: ElementRef;
    breadcrumbs = [
        {
            label: 'fe_special_offers_breadcrumb',
            url: 'check-your-reservation',
        },
    ];

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly validation: ValidationService,
    ) {}
    ngOnInit(): void {
        this.initForm();
    }

    private initForm(): void {
        const formGroup = {
            names: ['', Validators.compose([Validators.required])],
            lastName: ['', Validators.compose([Validators.required])],
            email: [
                '',
                Validators.compose([
                    Validators.required,
                    this.validation.validEmail,
                ]),
            ],
            phone: ['', Validators.compose([Validators.required])],
        };
        this.formInfoOffers = this.formBuilder.group(formGroup);
        this.loadingBtnOffers = false;
    }
    public onClickSendInfoOffers(): void {
        this.formInfoOffers.markAllAsTouched();
        this.loadingBtnOffers = true;
        if (!this.formInfoOffers.valid) {
            return;
        }
        this.formElement.nativeElement.submit();
    }
}
